(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frkm-cart-shipping-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('dialog:before-show', (event) => {
    if (event.target instanceof Element && event.target.matches('cart-drawer')) {
      event.target.querySelectorAll('.frkm-cart-shipping__details[open]').forEach((details) => {
        details.open = false;
      });
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frkm-gallery-labels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('frkm-gallery-labels')) {
    customElements.define('frkm-gallery-labels', class extends HTMLElement {
      connectedCallback() {
        const gallery = this.closest('product-gallery');
        if (!gallery) return;
        const synchronize = () => {
          const media = [...gallery.querySelectorAll('.product-gallery__carousel > .product-gallery__media')].filter(item => !item.hidden);
          const label = (template, index) => template.replaceAll('__FRKM_INDEX__', String(index)).replaceAll('__FRKM_COUNT__', String(media.length));
          media.forEach((item, index) => item.setAttribute('aria-label', label(this.dataset.itemLabel, index + 1)));
          gallery.querySelectorAll('product-gallery-navigation, carousel-navigation').forEach(navigation => {
            const buttons = [...navigation.children].filter(item => item.tagName === 'BUTTON' && !item.hidden);
            buttons.forEach((button, index) => {
              const text = label(this.dataset.goLabel, index + 1);
              button.setAttribute('aria-label', text);
              const accessibleText = button.querySelector('.sr-only');
              if (accessibleText && accessibleText.textContent !== text) accessibleText.textContent = text;
            });
          });
        };
        this.observer = new MutationObserver(synchronize);
        this.observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['hidden'], childList: true });
        queueMicrotask(synchronize);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["frkm-model-size-demo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('frkm-size-demo')) {
    class FrkmSizeDemo extends HTMLElement {
      connectedCallback() {
        if (this.dataset.placement !== 'modal' || this.dataset.enhanced === 'true') {
          return;
        }

        const source = this.querySelector('[data-frkm-size-demo-source]');
        const sourceTable = source?.querySelector('table');
        const sourceNote = source?.querySelector('.size-chart-note');
        const output = this.querySelector('[data-frkm-size-demo-output]');
        const controls = this.querySelector('[data-frkm-size-demo-controls]');
        const note = this.querySelector('[data-frkm-size-demo-note]');

        if (!source || !sourceTable || !sourceNote || !output || !controls || !note) {
          return;
        }

        const table = sourceTable.cloneNode(true);
        table.className = 'frkm-size-demo__table';
        table.removeAttribute('style');
        table.dataset.frkmColumns = String(table.querySelectorAll('thead th').length);

        const measurementCells = Array.from(table.querySelectorAll('tbody tr td:not(:first-child)'));
        let hasCompleteMeasurements = measurementCells.length > 0;

        measurementCells.forEach((cell) => {
          const sourceValue = cell.textContent.trim();
          const match = sourceValue.match(/^(-?\d+(?:\.\d+)?)\s*cm\s*\/\s*(-?\d+(?:\.\d+)?)\s*in$/i);

          if (/^(?:—|–|-)$/.test(sourceValue)) {
            cell.dataset.cm = sourceValue;
            cell.dataset.in = sourceValue;
            return;
          }

          if (sourceValue.length > 0 && !/\b(?:cm|in)\b/i.test(sourceValue)) {
            cell.dataset.cm = sourceValue;
            cell.dataset.in = sourceValue;
            cell.classList.add('frkm-size-demo__static');
            return;
          }

          if (!match) {
            hasCompleteMeasurements = false;
            return;
          }

          cell.dataset.cm = match[1];
          cell.dataset.in = match[2];
        });

        const noteMatch = sourceNote.textContent.match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)\s*cm/i);

        if (!hasCompleteMeasurements || !noteMatch) {
          return;
        }

        const buttons = Array.from(this.querySelectorAll('[data-frkm-size-demo-unit]'));
        const updateUnit = (unit) => {
          measurementCells.forEach((cell) => {
            cell.textContent = cell.dataset[unit];
          });

          buttons.forEach((button) => {
            const isActive = button.dataset.frkmSizeDemoUnit === unit;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
          });
        };

        output.replaceChildren(table);
        note.textContent = `${this.dataset.notePrefix} ${noteMatch[1]}–${noteMatch[2]} cm.`;

        buttons.forEach((button) => {
          button.addEventListener('click', () => updateUnit(button.dataset.frkmSizeDemoUnit));
        });

        updateUnit('cm');
        source.hidden = true;
        controls.hidden = false;
        output.hidden = false;
        note.hidden = false;
        this.dataset.enhanced = 'true';
      }
    }

    customElements.define('frkm-size-demo', FrkmSizeDemo);
  }
  } catch(e) { console.error(e); }
})();

})();
